export { SELECTION_CHANGE, SelectionDirection, SelectionMode } from '@uifabric/utilities';
//# sourceMappingURL=interfaces.js.map